import { Controller } from "@hotwired/stimulus"
import { planningMutation } from "../planning_mutation"

// Undo / redo for the capacity-planning board. Both call the board-action endpoints, which replay
// the stored inverse (or forward) ops and stream back the affected cells together with the
// authoritative button state.
//
// The keyboard path is NOT here: Mod+Z / Mod+Shift+Z are bound to the buttons themselves with
// `data-hotkey` (see undo_controls_component.html.erb) and reach these actions by clicking them.
// That keeps one shortcut registry for the whole app — the cheat sheet, the account's
// Tastaturkürzel setting and the typing/modal guards all apply without being reimplemented here,
// which a hand-rolled document keydown listener had to do and got subtly wrong on Caps Lock.
//
// The buttons never guess: every board mutation response re-renders this component from the real
// stack (see BaseController#undo_controls_stream), so the enabled state is always the server's.
export default class extends Controller {
  static targets = ["undoButton", "redoButton"]
  static values = { undoUrl: String, redoUrl: String, errorMessage: String }

  undo(event) {
    event?.preventDefault()
    this.run(this.undoUrlValue, this.hasUndoButtonTarget && this.undoButtonTarget.disabled)
  }

  redo(event) {
    event?.preventDefault()
    this.run(this.redoUrlValue, this.hasRedoButtonTarget && this.redoButtonTarget.disabled)
  }

  async run(url, disabled) {
    if (disabled || this.running) return

    this.running = true
    try {
      await planningMutation({
        url,
        method: "POST",
        errorMessage: this.errorMessageValue,
        component: "planning-undo",
      })
    } finally {
      this.running = false
    }
  }
}
